export default __webpack_public_path__ + "static/media/user24.475641bf.svg";